<template>
  <div class="bg-white p-2 rounded shadow cursor-pointer d-flex justify-content-between align-items-center"
       :class="{'border border-color-1' : isSelected}"
       @click="doCustomFilter(option.key)">
    <span class="text-capitalize">{{ option.value ? option.value : option.key }} ({{ option.count }})</span>
    <div class="d-flex align-items-center">
      <img src="@/assets/filter.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: "TypeFilter",
  props:{option:Object,isSelected:false},
  data(){
    return {
      selectedCustomFilter:null,
    }
  },
  methods:{
    doCustomFilter(){
      this.$emit("selected",this.option.key)
    }
  }
}
</script>

<style scoped>

</style>
